import { useState, useEffect, useRef, useCallback } from "react";
import {
  Parallax,
  ParallaxProvider,
} from "react-scroll-parallax";

import { motion } from "framer-motion";

import { gsap } from "gsap";

import "./HeroSection.scss";

const HeroSection = () => {
  const [heroImage] = useState([
    "https://images.unsplash.com/photo-1615421533158-f6c874badff4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDEwfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1615866431878-500cc9e74d82?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=668&q=80",
    "https://images.unsplash.com/photo-1604871000636-074fa5117945?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=668&q=80",
  ]);

  const constraintsRef = useRef();
  const heroSectionRef = useRef();
  const nameRef = useRef();
  const descriptionRef = useRef();

  const revealImage = useRef();
  const rightImage = useRef();

  const [name] = useState("AlbanBujupaj");
  const [description] = useState(
    "Creative Developer Bulding Interactive Web Applications"
  );

  const getRandomHeroImage = useCallback(() => {
    const randomImage = Math.floor(Math.random() * heroImage.length);
    return heroImage[randomImage];
  }, [heroImage]);

  function animation() {
    const heightDiff =
      rightImage.current.offsetHeight -
      rightImage.current.parentElement.offsetHeight;

    gsap.fromTo(
      rightImage.current,
      {
        translateY: -heightDiff,
      },
      {
        scrollTrigger: {
          trigger: rightImage.current.parentElement,
          scrub: true,
        },
        translateY: 0,
        ease: "none",
      }
    );

    const heroSectionTimeline = gsap.timeline();

    const revealAnim = revealImage.current;

    heroSectionTimeline.set(rightImage.current, { visibility: "hidden" });

    heroSectionTimeline
      .set(revealAnim, {
        scaleX: 0,
        duration: 0.5,
        transformOrigin: "left",
      })

      .to(revealAnim, {
        scaleX: 1,
        duration: 0.5,
        transformOrigin: "left",
        ease: "Power3.InOut",
      })
      .to(revealAnim, {
        scaleX: 0,
        duration: 0.5,
        transformOrigin: "right",
        ease: "Power3.InOut",
      })
      .to(rightImage.current, {
        visibility: "visible",
        duration: 2,
        scale: 1.2,
        ease: "Power3.InOut",
        delay: -0.5,
      });

    gsap.fromTo(
      nameRef.current.children,
      {
        y: "100%",
        opacity: 0,
      },
      {
        y: "0%",
        rotationX: 0,
        opacity: 1,
        delay: 0,
        stagger: {
          each: 0.04,
          from: "left",
        },
      }
    );

    gsap.set(document.querySelectorAll(".char"), {
      visibility: "hidden",
      opacity: 0,
      y: "100%",
    });

    heroSectionTimeline.to(document.querySelectorAll(".char"), {
      visibility: "visible",
      opacity: 1,
      y: 0,
      duration: 0.5,
      delay: -1.4,
      stagger: {
        each: 0.02,
        from: "left",
      },
    });
  }

  useEffect(() => {
    getRandomHeroImage();
    animation();
  }, [getRandomHeroImage]);

  return (
    <div className="hero-section" ref={heroSectionRef}>
      <h1 ref={nameRef} className="name">
        {name.split("").map((char, index) => (
          <span key={index}>{char.toUpperCase()}</span>
        ))}
      </h1>

      {/* <span className="split-line" /> */}
      <div className="hero-content">
        <div className="intro">
          <p
            ref={descriptionRef}
            className={`description is-visible`}
            aria-label={description}
          >
            {description.split(" ").map((char, index) => {
              return (
                <span
                  aria-hidden="true"
                  className="phrase"
                  key={index}
                  ref={constraintsRef}
                >
                  {char.split("").map((char, index) => {
                    return (
                      <motion.span
                        className="char"
                        key={index}
                        whileTap={{ scale: 1.2 }}
                        onClick={() => animation()}
                      >
                        {char}
                      </motion.span>
                    );
                  })}
                </span>
              );
            })}
          </p>

          <ParallaxProvider>
            <Parallax
              speed={-7}
              translateY={100}
              translateX={-200}
              easing={"easeInOutCubic"}
            >
              <div className="stage">
                <figure className="ball large">
                  <span className="shadow"></span>
                </figure>
              </div>
            </Parallax>

            <Parallax speed={20}>
              <div className="stage">
                <figure className="ball small">
                  <span className="shadow"></span>
                </figure>
              </div>
            </Parallax>
          </ParallaxProvider>
        </div>
      </div>
      <div className="image">
        <div
          className="image-right"
          ref={rightImage}
          style={{
            backgroundImage: `url(${getRandomHeroImage()})`,
          }}
        ></div>
        <div className="reveal" ref={revealImage}></div>
      </div>

      {/* <span className="blur-bg-decoration"></span>
      <span className="blur-bg-decoration-top-right"></span> */}

      {/* <div className="mar-text">
        <p>
          2021 Portfolio 2021 Portfolio 2021 Portfolio 2021 Portfolio 2021
          Portfolio 2021 Portfolio 2021 Portfolio 2021 Portfolio 2021 Portfolio{" "}
        </p>
      </div> */}
    </div>
  );
};

export default HeroSection;
